<!--说明-->
<!--1.type值12345对应A1、A2、A3、A4、B型题-->
<!--2.optionFlag表示多选还是单选-->
<!--3.B型题没有大题的题干。-->
<template>
  <div style="position: relative">
    <div class="Topic" @touchstart="touchstart" @touchend="touchend">
      <div
        class="display"
        v-if="T.type && T.questionId && Array.isArray(T.index)"
      >
        <div class="topic-top">
          <div class="topic-type">
            <TopicType :t="T.optionFlag" />
          </div>
          <TopicStemDescription :T="T" />
        </div>
        <div v-if="canSeeAnswer && T.type >= 2" class="topic-top topic-des">
          <div class="topic-type">
            <span class="tip">公共解析：</span>
            <div
              style="display: inline-block"
              v-html="T.answerContentHtml || T.answerContent"
            ></div>
          </div>
        </div>
        <div class="topic-content">
          <div v-if="T.type == 1 || T.type == 2" class="a1a2">
            <TopicOptions
              :T="T"
              :canSeeAnswer="canSeeAnswer"
              :optionFlag="T.optionFlag"
              :optionContent="T.optionContent"
              :answer="isHistory ? T.answer : []"
              v-model="T.userAnswer"
            />
          </div>
          <div v-else class="a3a4b">
            <ul>
              <li
                class="item"
                v-for="q in T.sonQuestion"
                :key="q.questionId"
                :data-questionId="q.questionId"
              >
                <div class="son-question-title">
                  <div class="no">
                    <template v-if="showIndex">{{ q.index[0] }}.</template>
                  </div>
                  <div class="title" v-html="q.stemDescriptionHtml"></div>
                </div>
                <TopicOptions
                  :T="T"
                  :q="q"
                  :canSeeAnswer="canSeeAnswer"
                  :optionFlag="T.optionFlag"
                  :optionContent="q.optionContent"
                  :answer="isHistory ? q.answer : []"
                  v-model="q.userAnswer"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else style="text-align: center;padding: 180px 0">
        数据加载中…
      </div>
    </div>
  </div>
</template>

<script>
import TopicType from "./TopicType.vue";
import TopicStemDescription from "./TopicStemDescription.vue";
import TopicOptions from "./TopicOptions.vue";

const isMoveDistanceVal = (document.documentElement.clientWidth / 8) * 3; //左右滑动的距离触发切换题目
export default {
  name: "Topic",
  props: {
    T: {
      //当前大题对象
      type: Object,
      default: function() {
        return {};
      }
    },
    canSeeAnswer: {
      type: Boolean,
      default: true
    },
    isHistory: {
      type: Boolean,
      default: false //目前有多处地方使用默认值，请勿随意修改
    },
    showIndex: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      startClientX: 0
    };
  },
  mounted: function() {},
  methods: {
    touchstart(e) {
      this.startClientX = e.changedTouches[0].clientX;
    },
    touchend(e) {
      let endClientX = e.changedTouches[0].clientX;
      if (this.startClientX > endClientX) {
        //下一题
        if (this.startClientX - endClientX > isMoveDistanceVal) {
          this.$emit("swipe", 1);
        }
      } else {
        //上一题
        if (endClientX - this.startClientX > isMoveDistanceVal) {
          this.$emit("swipe", 0);
        }
      }
    }
  },
  components: { TopicOptions, TopicType, TopicStemDescription }
};
</script>

<style lang="scss">
.Topic {
  overflow: hidden;
  background: #fff;

  video {
    width: 100%;
  }

  img {
    width: 100%;
  }

  audio {
    width: 100%;
  }

  .topic-top {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 2px 17px;
    background: #f5f7f9;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 5px;
    border-bottom: 0;

    .topic-type {
      padding: 0 16px 0 0;

      .tip {
        color: #333;
        font-weight: bold;
        font-size: 19px;
      }
    }
  }

  .topic-des {
    border: 1px solid #eeeeee;
    border-top: 0;
    border-radius: 5px;
  }

  .topic-content {
    margin-top: 20px;
    padding: 30px;
    background: #fcfcfc;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 5px;

    .a3a4b {
      ul {
        margin-top: 0;

        .item {
          list-style-type: none;
          margin-bottom: 20px;
        }
      }
    }

    .son-question-title {
      display: flex;
      min-height: 40px;
      align-items: center;

      .title {
        flex: 1;
        margin-top: 0;
        table-layout: fixed;
        word-break: break-all;
        overflow: hidden;
      }
    }
  }
}
</style>
